export default __webpack_public_path__ + "static/media/avatar_merlion5.ff31f4a2.mp3";